import React from 'react';
import PropTypes from 'prop-types';

import './Form.scss';

const FormError = (
  {
    children,
    ...props
  }
) => <div className="Form__Error" role="alert" aria-live="polite" {...props}>{children}</div>;

FormError.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormError;
